import Button from "../CustomButtons/Button.js";
import Image from "next/image.js";

import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {mergeRegister} from '@lexical/utils';
import {$isLinkNode, TOGGLE_LINK_COMMAND} from '@lexical/link';
import {
  $getSelection,
  $isRangeSelection,
  FORMAT_ELEMENT_COMMAND,
  FORMAT_TEXT_COMMAND,
  SELECTION_CHANGE_COMMAND,
  TEXT_CONTENT_COMMAND
} from 'lexical';
import {useCallback, useEffect, useRef, useState} from 'react';
import { makeStyles } from "tss-react/mui";
import styles from "../../styles/jss/nextjs-material-kit/pages/forumsStyle.js";

import EmojiPickerPlugin from "./EmojiPickerPlugin.js";


const useStyles = makeStyles()(styles);

const LowPriority = 1;

export default function ForumsLexicalToolbar(props) {
  const {cx, classes} = useStyles();
  const { setImageDialogOpen, imageDialogOpen, setEmojiPickerOpen, emojiPickerOpen } = props;

  const [editor] = useLexicalComposerContext();
  const toolbarRef = useRef(null);

  const [isItalic, setIsItalic] = useState(false);
  const [isBold, setIsBold] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [linkUrl, setLinkUrl] = useState('');

  const $updateToolbar = useCallback(() => {
    const selection = $getSelection();
    if ($isRangeSelection(selection)) {
      setIsBold(selection.hasFormat('bold'));
      setIsItalic(selection.hasFormat('italic'));
      setIsUnderline(selection.hasFormat('underline'));
      setLinkUrl(`https://${selection.getTextContent()}`);
    }
  }, []);

  useEffect(() => {
    return mergeRegister(
      editor.registerUpdateListener(({editorState}) => {
        editorState.read(() => {
          $updateToolbar();
        });
      }),
      editor.registerCommand(
        SELECTION_CHANGE_COMMAND,
        (_payload, _newEditor) => {
          $updateToolbar();
          return false;
        },
        LowPriority,
      ),
      editor.registerCommand(
        TEXT_CONTENT_COMMAND, // Listen for text content changes
        (_payload, _newEditor) => {
          $updateToolbar(); // Update toolbar when text content changes
          return false;
        },
        LowPriority,
      ),
    );
  }, [editor, $updateToolbar]);

  const toggleImageDialog = () => {
    setImageDialogOpen(!imageDialogOpen);
  }

  const toggleEmojiPicker = () => {
    setEmojiPickerOpen(!emojiPickerOpen);
  }

  return (
    <div className={classes.lexicalToolbar} ref={toolbarRef}>
      <Button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic');
        }}
        className={`${classes.transparentButton} ${classes.smallButton} ${(isItalic ? classes.toolbarItemActive : classes.toolbarItem)}`}
        aria-label="Format Italic">
        <Image src="/img/forums/icons/italicIcon.png" alt="Italic Icon" width={25} height={25} />
      </Button>
      <Button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
        }}
        className={`${classes.transparentButton} ${classes.smallButton} ${(isBold ? classes.toolbarItemActive : classes.toolbarItem)}`}
        aria-label="Format Bold">
        <Image src="/img/forums/icons/boldIcon.png" alt="Bold Icon" width={25} height={25} />
      </Button>
      <Button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'underline');
        }}
        className={`${classes.transparentButton} ${classes.smallButton} ${(isUnderline ? classes.toolbarItemActive : classes.toolbarItem)}`}
        aria-label="Format Underline">
        <Image src="/img/forums/icons/underlineIcon.png" alt="Underline Icon" width={25} height={25} />
      </Button>
      <Button
        onClick={() => {
          editor.dispatchCommand(TOGGLE_LINK_COMMAND, linkUrl);
        }}
        className={classes.transparentButton + " " + classes.smallButton + " " + classes.toolbarItem}
        aria-label="Add link">
        <Image src="/img/forums/icons/linkIconBlack.png" alt="Link Icon" width={25} height={25} />
      </Button>
      <Button
        onClick={toggleEmojiPicker}
        className={classes.transparentButton + " " + classes.smallButton + " " + classes.desktopView + " " + classes.toolbarItem}
        aria-label="Add emoji">
        <Image src="/img/forums/icons/emojiIcon.png" alt="Emoji Icon" width={25} height={25} />
      </Button>
      {/* Images currently switched off */}
      {/* <Button
        onClick={toggleImageDialog}
        className={classes.transparentButton + " " + classes.smallButton + " " + classes.toolbarItem}
        aria-label="Add image">
        <Image src="/img/forums/icons/imageIcon.png" alt="Image Icon" width={25} height={25} />
      </Button> */}
      {/* TODO - Add GIF */}
      {/* <Button
        onClick={() => {
          editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold');
        }}
        className={classes.transparentButton + " " + classes.smallButton}
        aria-label="Add GIF">
        <Image src="/img/forums/icons/gifIcon.png" alt="GIF Icon" width={25} height={25} />
      </Button> */}
    </div>
  );
}
